<template>
  <span v-text="formatted" />
</template>

<script>
import { format } from "date-fns"

export default {
  props: {
    value: { type: [Date, String], default: null },
    date: { type: Boolean, default: false },
    time: { type: Boolean, default: false },
    dateFormat: { type: String, default: "d. M. yyyy" },
    timeFormat: { type: String, default: "H:mm" },
  },
  computed: {
    formatString() {
      return [
        this.date ? this.dateFormat : null,
        this.time ? this.timeFormat : null,
      ]
        .filter(f => f !== null)
        .join(" ")
    },
    formatted() {
      if (this.value) {
        const date =
          typeof this.value === "string" ? Date.parse(this.value) : this.value

        return format(date, this.formatString)
      }

      return ""
    },
  },
}
</script>
